// extracted by mini-css-extract-plugin
export default {"grid":"productItem_grid__zCdxa","img":"productItem_img__Cc7dp","content":"productItem_content__bOvwm","details":"productItem_details__eQ7jD","list":"productItem_list__NeOV5"};